module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "fi-pc cooperate-container"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_c('fi-header'), _vm._v(" "), _c('div', {
    staticClass: "cooperate"
  }, [_c('div', {
    staticClass: "dd-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cooperate-list"
  }, [_c('div', {
    staticClass: "bew clearfix"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    attrs: {
      "placeholder": "",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bew clearfix"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "placeholder": "",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bew clearfix"
  }, [_c('div', {
    staticClass: "item brief"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "flat-btn",
    on: {
      "click": _vm.sendHandle
    }
  }, [_c('span', [_vm._v("发送")]), _c('i')])])], 1), _vm._v(" "), _c('fi-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("姓名")]), _vm._v(" "), _c('span', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("公司")]), _vm._v(" "), _c('span', [_vm._v("ITD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("电话")]), _vm._v(" "), _c('span', [_vm._v("Call")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("邮箱")]), _vm._v(" "), _c('span', [_vm._v("E-mail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("描述")]), _vm._v(" "), _c('span', [_vm._v("Brief")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f7767"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Cooperate.vue
// module id = 375
// module chunks = 1